import React from 'react';

export const PinchToZoom = () => (
    <>
        <path d='M18 10h-4v-4' />
        <path d='M20 4l-6 6' />
        <path d='M6 14h4v4' />
        <path d='M10 14l-6 6' />
    </>
);